import React from 'react';
import Image from '../../Image';
import {
  LargeLocker1_1,
  LargeLocker1_2,
  LargeLocker1_3,
  LargeLocker1_4,
  LargeLocker2_1,
  LargeLocker2_2,
  LargeLocker2_3,
  LargeLocker2_4,
} from '../../../assets/Images/cab-size/large-locker';
import {
  RegularLocker1_1,
  RegularLocker1_2,
  RegularLocker1_3,
  RegularLocker2_1,
  RegularLocker2_2,
  RegularLocker2_3,
  RegularLocker2_4,
  RegularLocker3_1,
  RegularLocker3_2,
  RegularLocker3_3,
  RegularLocker3_4,
  RegularLocker4_1,
  RegularLocker4_2,
  RegularLocker5_1,
  RegularLocker5_2,
  RegularLocker5_3,
  RegularLocker5_4,
} from '../../../assets/Images/cab-size/regular-locker';

const CabBoxOpenedImage: React.FC<Props> = ({
  cabSizeType,
  lockAddress,
  lockPort,
  width,
  height
}) => {
  // 图片比例，宽高比
  const scale = cabSizeType === 'large' ? (364 / 557) : (368 / 550);
  const [imgWidth, setImgWidth] = React.useState<number>();
  const [imgHeight, setImgHeight] = React.useState<number>();

  React.useEffect(() => {
    if (width) {
      setImgWidth(width);
      setImgHeight(width / scale);
    }
    else if (height) {
      setImgWidth(height * scale);
      setImgHeight(height);
    }
  }, [width, height]);

  if (cabSizeType === 'large') {
    if (lockAddress === 1 && lockPort === 1) {
      return (
        <Image srcImg={LargeLocker1_1} style={{ width: imgWidth, height: imgHeight }} alt="" />
      );
    }
    if (lockAddress === 1 && lockPort === 2) {
      return (
        <Image srcImg={LargeLocker1_2} style={{ width: imgWidth, height: imgHeight }} alt="" />
      );
    }
    if (lockAddress === 1 && lockPort === 3) {
      return (
        <Image srcImg={LargeLocker1_3} style={{ width: imgWidth, height: imgHeight }} alt="" />
      );
    }
    if (lockAddress === 1 && lockPort === 4) {
      return (
        <Image srcImg={LargeLocker1_4} style={{ width: imgWidth, height: imgHeight }} alt="" />
      );
    }
    if (lockAddress === 2 && lockPort === 1) {
      return (
        <Image srcImg={LargeLocker2_1} style={{ width: imgWidth, height: imgHeight }} alt="" />
      );
    }
    if (lockAddress === 2 && lockPort === 2) {
      return (
        <Image srcImg={LargeLocker2_2} style={{ width: imgWidth, height: imgHeight }} alt="" />
      );
    }
    if (lockAddress === 2 && lockPort === 3) {
      return (
        <Image srcImg={LargeLocker2_3} style={{ width: imgWidth, height: imgHeight }} alt="" />
      );
    }
    if (lockAddress === 2 && lockPort === 4) {
      return (
        <Image srcImg={LargeLocker2_4} style={{ width: imgWidth, height: imgHeight }} alt="" />
      );
    }
  }
  else {
    if (lockAddress === 1 && lockPort === 1) {
      return (
        <Image srcImg={RegularLocker1_1} style={{ width: imgWidth, height: imgHeight }} alt="" />
      );
    }
    if (lockAddress === 1 && lockPort === 2) {
      return (
        <Image srcImg={RegularLocker1_2} style={{ width: imgWidth, height: imgHeight }} alt="" />
      );
    }
    if (lockAddress === 1 && lockPort === 3) {
      return (
        <Image srcImg={RegularLocker1_3} style={{ width: imgWidth, height: imgHeight }} alt="" />
      );
    }
    if (lockAddress === 2 && lockPort === 1) {
      return (
        <Image srcImg={RegularLocker2_1} style={{ width: imgWidth, height: imgHeight }} alt="" />
      );
    }
    if (lockAddress === 2 && lockPort === 2) {
      return (
        <Image srcImg={RegularLocker2_2} style={{ width: imgWidth, height: imgHeight }} alt="" />
      );
    }
    if (lockAddress === 2 && lockPort === 3) {
      return (
        <Image srcImg={RegularLocker2_3} style={{ width: imgWidth, height: imgHeight }} alt="" />
      );
    }
    if (lockAddress === 2 && lockPort === 4) {
      return (
        <Image srcImg={RegularLocker2_4} style={{ width: imgWidth, height: imgHeight }} alt="" />
      );
    }
    if (lockAddress === 3 && lockPort === 1) {
      return (
        <Image srcImg={RegularLocker3_1} style={{ width: imgWidth, height: imgHeight }} alt="" />
      );
    }
    if (lockAddress === 3 && lockPort === 2) {
      return (
        <Image srcImg={RegularLocker3_2} style={{ width: imgWidth, height: imgHeight }} alt="" />
      );
    }
    if (lockAddress === 3 && lockPort === 3) {
      return (
        <Image srcImg={RegularLocker3_3} style={{ width: imgWidth, height: imgHeight }} alt="" />
      );
    }
    if (lockAddress === 3 && lockPort === 4) {
      return (
        <Image srcImg={RegularLocker3_4} style={{ width: imgWidth, height: imgHeight }} alt="" />
      );
    }
    if (lockAddress === 4 && lockPort === 1) {
      return (
        <Image srcImg={RegularLocker4_1} style={{ width: imgWidth, height: imgHeight }} alt="" />
      );
    }
    if (lockAddress === 4 && lockPort === 2) {
      return (
        <Image srcImg={RegularLocker4_2} style={{ width: imgWidth, height: imgHeight }} alt="" />
      );
    }
    if (lockAddress === 5 && lockPort === 1) {
      return (
        <Image srcImg={RegularLocker5_1} style={{ width: imgWidth, height: imgHeight }} alt="" />
      );
    }
    if (lockAddress === 5 && lockPort === 2) {
      return (
        <Image srcImg={RegularLocker5_2} style={{ width: imgWidth, height: imgHeight }} alt="" />
      );
    }
    if (lockAddress === 5 && lockPort === 3) {
      return (
        <Image srcImg={RegularLocker5_3} style={{ width: imgWidth, height: imgHeight }} alt="" />
      );
    }
    if (lockAddress === 5 && lockPort === 4) {
      return (
        <Image srcImg={RegularLocker5_4} style={{ width: imgWidth, height: imgHeight }} alt="" />
      );
    }
  }

  return (
    <></>
  );
};

export interface Props {
  cabSizeType: string; // small=小柜，medium=中柜，large=大柜
  lockAddress: number;
  lockPort: number;
  width?: number;
  height?: number;
}

export default CabBoxOpenedImage;
